import { render } from "./TopPicks.vue?vue&type=template&id=e5b5114c&scoped=true"
import script from "./TopPicks.vue?vue&type=script&lang=js"
export * from "./TopPicks.vue?vue&type=script&lang=js"

import "./TopPicks.vue?vue&type=style&index=0&id=e5b5114c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b5114c"]])

export default __exports__